import type { PhaseSheet } from "~/lib/constants/process";

/**
 * The artifact a phase leaves behind. Four shapes, one per phase, rather than
 * the same card four times: a scoped brief, a sheet of tested scenarios, a
 * handover checklist, an improvement log.
 *
 * Every one of them carries a caption or marker saying it is illustrative.
 */
export function PhaseSheetArt({ sheet }: Readonly<{ sheet: PhaseSheet }>) {
  if (sheet.kind === "brief") {
    return (
      <div className="brief-sheet">
        <p className="sheet-title">
          {sheet.title} <span>{sheet.marker}</span>
        </p>
        <dl>
          {sheet.rows.map((row) => (
            <div key={row.term}>
              <dt>{row.term}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    );
  }

  if (sheet.kind === "check") {
    return (
      <div className="check-sheet">
        <h3>{sheet.title}</h3>
        {sheet.cases.map((testCase) => (
          <div className="test-case" key={testCase.label}>
            {testCase.label}
            {/* The state is the outcome, and two of the four hand back to a
                person. Colour marks which, but the words carry it alone. */}
            <span className={testCase.needsPerson ? "needs-person" : undefined}>
              {testCase.state}
            </span>
          </div>
        ))}
        <p className="small-note">{sheet.note}</p>
      </div>
    );
  }

  if (sheet.kind === "handover") {
    return (
      <div className="handover-sheet">
        <h3>{sheet.title}</h3>
        {sheet.items.map((item) => (
          <div key={item}>
            <span aria-hidden="true">✓</span> {item}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="log-sheet">
      <h3>{sheet.title}</h3>
      {sheet.entries.map((entry) => (
        <div className="log-entry" key={entry.title}>
          <strong>{entry.title}</strong>
          <p>{entry.body}</p>
        </div>
      ))}
      <p className="small-note">{sheet.note}</p>
    </div>
  );
}
